import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { unstable_HistoryRouter as HistoryRouter, useLocation } from 'react-router-dom'
import sharedHistory from './history'

const ROUTER_FUTURE_FLAGS = {
  v7_startTransition: true,
  v7_relativeSplatPath: true
}

function RouterUpdateListener({ onUpdate = undefined }) {
  const location = useLocation()

  useEffect(() => {
    if (typeof onUpdate === 'function') {
      onUpdate(location)
    }
  }, [location, onUpdate])

  return null
}

RouterUpdateListener.propTypes = {
  onUpdate: PropTypes.func
}

function Router({ children = null, history = undefined, onUpdate = undefined }) {
  const routerHistory = history || sharedHistory

  return (
    <HistoryRouter history={routerHistory} future={ROUTER_FUTURE_FLAGS}>
      <RouterUpdateListener onUpdate={onUpdate} />
      {children}
    </HistoryRouter>
  )
}

Router.propTypes = {
  children: PropTypes.node,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    replace: PropTypes.func.isRequired,
    go: PropTypes.func.isRequired,
    listen: PropTypes.func.isRequired
  }),
  onUpdate: PropTypes.func
}

export default Router
